import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DietPlanApi } from '../api/dietplan.api';
import { switchMap, map } from 'rxjs/operators';

import { DietPlanData, DietPlan } from '../../../interfaces/masters/dietplan' ;
@Injectable()
export class DietPlanService extends DietPlanData {

    constructor(private api: DietPlanApi) {
      super();
    }
  
  
    list(url: string): Observable<DietPlan[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<DietPlan>{
        return this.api.getById(url);
    }
  
    create(url: string, data:DietPlan): Observable<DietPlan[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:DietPlan): Observable<DietPlan> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  